// @USAGE
// const dispatch = useDispatch();
// const cache_reducer = useSelector(state => state.cache_reducer);
// > set : dispatch(cache_actions.{function});
// > get : cache_reducer.{key_name_of_state}

import {createSlice} from "@reduxjs/toolkit";

const init_state = {
    // ... model request keys
};

const cache_slice = createSlice({
    name: "cache",
    initialState: init_state,
    reducers: {
        set(state, {payload}) {
            state[payload.key] = {
                value: payload.value,
                cache_policy: payload.cache_policy,
                time: new Date().getTime(),
            };
        },
        remove(state, {payload}) {
            delete state[payload.key];
        },
        removeAll(state) {
            state = init_state;
        },
    },
});

export const cache_actions = cache_slice.actions;
export default cache_slice.reducer;
